'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineContentAdvisoryEditor = require('./components/InlineContentAdvisoryEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineContentAdvisoryEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/inline-content-advisory-editor/index.js
// module id = 1517
// module chunks = 1